require('./ProgramGallery.scss');

const b = require('app/www/libs/b')('program-gallery');

const _ = {
    get: require('lodash/get'),
    isEmpty: require('lodash/isEmpty'),
};

const React = require('react');
const PropTypes = require('prop-types');

const Metrika = require('app/www/libs/client/metrika');
const nextTick = require('app/www/libs/nextTick');
const {getNearestSize} = require('app/common/libs/image');

const {withI18n} = require('app/www/components/contexts/I18n');

const Button = require('app/www/components/blocks/Button/Button');
const Carousel = require('app/www/components/blocks/Carousel/Carousel');
const Image = require('app/www/components/blocks/Image/Image');
const Modal = require('app/www/components/blocks/Modal/Modal');
const ResizeListener = require('app/www/components/blocks/ResizeListener/ResizeListener');
const Scroll = require('app/www/components/blocks/Scroll/Scroll');
const Spin = require('app/www/components/blocks/Spin/Spin');
const TrailerSchemaOrg = require('app/www/components/blocks/TrailerSchemaOrg/TrailerSchemaOrg');
const Ua = require('app/www/components/blocks/Ua/Ua');
const Video = require('app/www/components/blocks/Video/Video');

const PREVIWS_OPTIONS = {
    0: {
        mod: 'zero',
        sizes: [0],
    },
    1: {
        mod: 'one',
        sizes: [628],
    },
    2: {
        mod: 'two',
        sizes: [312, 312],
    },
    3: {
        mod: 'three',
        sizes: [420, 204],
    },
};

const PREVIEWS_MAX = 3;
const PREVIEWS_PHONE_WIDTH = 240;

const ITEMS_RENDERED = 5;
const ITEMS_REMAINED = 2;

const GALLERY_OFFSET = 192;

const HASH = '#gallery';

class ProgramGallery extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {};

        const {items} = this.props;

        this._previewsAll = items.map(item => {
            if (item.preview) {
                item.preview.isTrailer = true;
                return item.preview;
            }

            return item;
        });

        if (Ua.displayWidth) {
            this._setPreviewWidth();
        }

        this._previews = this._previewsAll.slice(0, PREVIEWS_MAX);
        this._galleryMod = PREVIWS_OPTIONS[this._previews.length].mod;
        this._itemsMore = items.length - this._previews.length;
        this._itemsOffsets = [];

        this.onClickPreview = this.onClickPreview.bind(this);
        this._renderPreview = this._renderPreview.bind(this);
        this._renderItem = this._renderItem.bind(this);
        this._onResize = this._onResize.bind(this);
        this._close = this._close.bind(this);
        this._onScrollToItem = this._onScrollToItem.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onClose = this._onClose.bind(this);
        this._onHashChange = this._onHashChange.bind(this);
    }

    componentDidMount() {
        this._setGalleryWidths();

        if (!this._hasPreviewWidth) {
            nextTick(() => {
                this._setPreviewWidth();

                this.setState({
                    update: true,
                });
            });
        }

        if (location.hash === HASH) {
            location.hash = '';
        }

        window.addEventListener('hashchange', this._onHashChange);

        this._sendMetrika('show');
    }

    componentWillUnmount() {
        window.removeEventListener('hashchange', this._onHashChange);
    }

    render() {
        const {itemIndex} = this.state;
        const {i18n, items, isLayoutColumnsSmall, programTitle} = this.props;

        const previews = isLayoutColumnsSmall ? this._previewsAll : this._previews;
        const hasTrailer = Boolean(items[0].video);

        const spinProps = {
            mods: {
                size: 'm',
            },
        };

        const scrollProps = {
            touch: true,
            render: this._renderPreview,
            autoLoad: isLayoutColumnsSmall && {
                itemsRendered: ITEMS_RENDERED,
                itemsRemained: ITEMS_REMAINED,
                itemWidth: PREVIEWS_PHONE_WIDTH,
            },
        };

        const modalProps = {
            mods: {
                animate: false,
            },
            onClose: this._onClose,
        };

        const carouselProps = {
            mods: {
                gallery: true,
                video: Boolean(_.get(items, `[${itemIndex}].video`)),
            },
            animate: false,
            hotKeys: true,
            forceControls: true,
            width: this._galleryWidth,
            scrollWidth: this._galleryWidth,
            onScroll: this._onScrollToItem,
            render: this._renderItem,
            autoLoad: {
                itemsRendered: ITEMS_RENDERED + this._itemIndex,
                itemsRemained: ITEMS_REMAINED,
                itemWidth: this._galleryWidth,
            },
        };

        const closeProps = {
            onClick: this._close,
        };

        const resizeListenerProps = {
            callback: this._onResize,
        };

        let metaDescription;

        if (items[itemIndex] && items[itemIndex].video) {
            metaDescription = i18n.get('gallery.trailer');
        } else {
            metaDescription = i18n.get('gallery.meta',
                hasTrailer ? {
                    number: itemIndex,
                    numbers: items.length - 1,
                } : {
                    number: itemIndex + 1,
                    numbers: items.length,
                }
            );
        }

        const trailerSchemaOrgProps = {
            trailer: items[0],
            title: programTitle,
        };

        let seoImageIndex;

        if (!hasTrailer) {
            seoImageIndex = 0;
        } else if (items.length > 1) {
            seoImageIndex = 1;
        }

        return (
            <section
                ref={elem => (this.gallery = elem)}
                className={b({layout: this._galleryMod})}
                itemProp="image" itemScope itemType="http://schema.org/ImageObject"
            >
                {!Ua.displayWidth && !Ua.isOldOpera && (
                    <Spin className={b('spin')} {...spinProps} />
                )}
                <Scroll {...scrollProps}>{previews}</Scroll>
                {typeof itemIndex !== 'undefined' && (
                    <Modal
                        ref={elem => (this.modal = elem)}
                        className={b('modal')}
                        owner={this.gallery}
                        {...modalProps}
                    >
                        <div
                            className={b('content')}
                            onClick={this._onClick}
                        >
                            <i className={b('close')} {...closeProps} />
                            <div className={b('meta')}>
                                <span className={b('meta-title')}>
                                    {programTitle}
                                </span>
                                <span className={b('meta-description')}>
                                    {metaDescription}
                                </span>
                            </div>
                            <Carousel
                                ref={elem => (this._carousel = elem)}
                                {...carouselProps}
                            >
                                {items}
                            </Carousel>
                        </div>
                    </Modal>
                )}
                {hasTrailer && (
                    <TrailerSchemaOrg key="schema" {...trailerSchemaOrgProps} />
                )}
                {typeof seoImageIndex !== 'undefined' && (
                    <meta itemProp="url" content={`https:${this._preview(items[seoImageIndex], 0).url}`} />
                )}
                <ResizeListener {...resizeListenerProps} />
            </section>
        );
    }

    /**
     * Открываем галерею и прокручиваем до выбранного элемента
     * @param {Number} itemIndex индекс элемента
     * @param {Boolean} [isButton] открытие по кнопке
     * @returns {Object}
     * @private
     */
    onClickPreview(itemIndex, isButton) {
        return () => {
            this._itemIndex = itemIndex;

            this.setState({
                itemIndex,
            });

            nextTick(() => {
                this._isButton = isButton;
                const position = itemIndex * this._galleryWidth;
                this._carousel.scroll(position);
                this.modal.open();
                this._changeHistory(true);
            });
        };
    }

    /**
     * Сохраняем размеры галереи
     * @private
     */
    _setGalleryWidths() {
        this._galleryWidth = document.documentElement.clientWidth;
        this._galleryHeight = document.documentElement.clientHeight - (Ua.isTouch ? 0 : GALLERY_OFFSET);
    }

    /**
     * Сохраняем размеры превью
     * @private
     */
    _setPreviewWidth() {
        this._previewWidth = null;
        this._hasPreviewWidth = true;

        if (Ua.isLayoutColumnsSmall) {
            this._previewWidth = PREVIEWS_PHONE_WIDTH;
        }
    }

    /**
     * Определяем размер и урл превью
     * @param {Object} image изображение
     * @param {Number} index индекс
     * @returns {Object}
     * @property {Number} size
     * @property {String} url
     * @private
     */
    _preview(image, index) {
        let neededSize = this._previewWidth;

        if (!neededSize) {
            neededSize = PREVIWS_OPTIONS[this._previews.length].sizes[index ? 1 : 0];
        }

        const nearestSize = getNearestSize(image.sizes, neededSize);
        const {src} = nearestSize < neededSize && image.original || image.sizes[nearestSize];

        return {
            size: neededSize,
            url: src,
        };
    }

    /**
     * Рендерим превью
     * @param {Object} preview
     * @param {Number} index
     * @returns {Object}
     * @private
     */
    _renderPreview(preview, index) {
        const {i18n, isLayoutColumnsSmall} = this.props;

        const frames = this._previews.length > 1 && ((index === 0 && !this._previews[0].isTrailer) || (index === 1 && this._previews[0].isTrailer));
        const more = this._previews.length > 1 && this._itemsMore > 0 && index === this._previews.length - 1;
        const trailer = !more && preview.isTrailer;
        const hidden = !this._hasPreviewWidth;

        const previewMods = {
            frames,
            trailer,
            more,
            hidden,
        };

        const previewProps = {
            onClick: this.onClickPreview(index),
        };

        if (this._hasPreviewWidth) {
            const {size, url} = this._preview(preview, index);

            previewProps.style = {
                width: size,
                backgroundImage: `url('${url}')`,
            };
        }

        const buttonProps = {
            mods: {
                size: isLayoutColumnsSmall ? 'xl' : '2xl',
                pin: 'circle',
                icon: 'bright',
                'only-icon': true,
            },
            icon: {
                play: true,
                size: isLayoutColumnsSmall ? 'm' : 'l',
            },
        };

        return (
            <span
                key={index}
                className={b('preview', previewMods)}
                {...previewProps}
            >
                {frames && (
                    <span className={b('preview-text')}>
                        {i18n.get('gallery.frames')}
                    </span>
                )}
                {trailer && [
                    <span key="text" className={b('preview-text')}>
                        {i18n.get('gallery.trailer')}
                    </span>,
                    Ua.displayWidth && (
                        <Button key="button" {...buttonProps} />
                    ),
                ]}
                {more && (
                    <i className={b('more')}>
                        +{this._itemsMore + 1}
                    </i>
                )}
            </span>
        );
    }

    /**
     * Изменяем историю браузера
     * Если галерея открыта, добавляется хеш
     * @param {Boolean} isOpen
     * @private
     */
    _changeHistory(isOpen) {
        if (!window.Modernizr.history) {
            return;
        }

        this._isOpen = isOpen;

        if (isOpen) {
            const url = [
                location.pathname,
                location.search,
                HASH,
            ].join('');

            window.history.pushState('', document.title, url);
        } else {
            window.history.back();
        }
    }

    /**
     * Закрываем галерею
     * @private
     */
    _close() {
        this.modal.close();
    }

    /**
     * @private
     */
    _onResize() {
        this._setGalleryWidths();
        this._setPreviewWidth();

        if (this.modal) {
            this._close();
        }
    }

    /**
     * Получаем пропсы для трейлера или изображения
     * @param {Object} item
     * @param {Number} index
     * @returns {Object}
     * @private
     */
    _getItemProps(item, index) {
        const {items} = this.props;
        const nearestSize = getNearestSize((item.preview || item).sizes, this._galleryWidth);

        if (item.video) {
            this._setOffset(index, nearestSize);

            return {
                isTrailer: true,
                src: item.video,
                allowFullScreen: true,
                width: this._galleryWidth,
                height: this._galleryHeight,
                allow: 'autoplay; encrypted-media',
                style: {
                    maxHeight: this._galleryHeight,
                },
            };
        }

        let nearestImage = item.sizes[nearestSize];

        if (
            Ua.isTouch ||
            nearestImage.width > this._galleryWidth &&
            nearestImage.height > this._galleryHeight
        ) {
            if (this._galleryHeight > this._galleryWidth) {
                nearestImage = this._setImageMaxWidth(nearestImage);
            } else {
                nearestImage = this._setImageMaxHeight(nearestImage);
            }
        } else if (nearestImage.width > this._galleryWidth) {
            nearestImage = this._setImageMaxWidth(nearestImage);
        } else if (nearestImage.height > this._galleryHeight) {
            nearestImage = this._setImageMaxHeight(nearestImage);
        }

        const itemProps = {
            sizes: {
                [nearestSize]: nearestImage,
            },
        };

        if (this._itemsOffsets.length !== items.length) {
            itemProps.onLoad = evt => this._setOffset(index, evt.target.width);
        }

        return itemProps;
    }

    /**
     * Устанавливаем изображению ширину, равную ширине галереи
     * Сохраняем пропорции изображения
     * @param {Object} image
     * @returns {Object}
     * @private
     */
    _setImageMaxWidth(image) {
        return Object.assign({}, image, {
            width: this._galleryWidth,
            height: image.height / image.width * this._galleryWidth,
        });
    }

    /**
     * Устанавливаем изображению высоту, равную высоте галереи
     * Сохраняем пропорции изображения
     * @param {Object} image
     * @returns {Object}
     * @private
     */
    _setImageMaxHeight(image) {
        return Object.assign({}, image, {
            height: this._galleryHeight,
            width: image.width / image.height * this._galleryHeight,
        });
    }

    /**
     * Сохраняем в массив отступ элемента от левого края экрана
     * @param {Number} index
     * @param {Number} width
     * @private
     */
    _setOffset(index, width) {
        this._itemsOffsets[index] = (this._galleryWidth - width) / 2;
    }

    /**
     * Рендерим элемент галереи
     * @param {Object} item
     * @param {Number} index
     * @returns {Object}
     * @private
     */
    _renderItem(item, index) {
        const {itemIndex} = this.state;
        const props = this._getItemProps(item, index);
        const visible = index === itemIndex;
        const isTrailer = Boolean(item.video);

        const itemStyle = {
            width: this._galleryWidth,
            maxHeight: this._galleryHeight,
        };

        return (
            <div
                key={index}
                className={b('item', {
                    visible,
                    trailer: isTrailer,
                })}
                style={itemStyle}
            >
                {isTrailer
                    ? visible && <Video className={b('iframe')} {...props} />
                    : <Image {...props} />
                }
            </div>
        );
    }

    /**
     * Отправляем данные в метрику
     * @param {String} action show|click
     * @private
     */
    _sendMetrika(action) {
        const {items, programId, eventId} = this.props;
        const {itemIndex} = this.state;

        let isTrailer;

        switch (action) {
            case 'show':
                isTrailer = items.some(item => item.video);
                break;

            case 'click':
                if (!this._isOpen) {
                    return;
                }

                isTrailer = items[itemIndex].video;
                break;

            default:
                return;
        }

        let component;

        if (isTrailer) {
            component = `trailer_${this._isButton ? 'button' : 'gallery'}`;
        } else {
            component = 'img_gallery';
        }

        Metrika.trackParams('PROGRAM_PAGE', {
            component,
            action,
            programId,
            eventId,
        });
    }

    /**
     * Определяем порядковый номер выбранного элемента
     * @param position
     * @private
     */
    _onScrollToItem(position) {
        this.setState({
            itemIndex: Math.round(position / this._galleryWidth),
        }, () => {
            this._sendMetrika('click');
        });
    }

    /**
     * @param {Object} evt
     * @private
     */
    _onClick(evt) {
        const {className} = evt.target;
        const closeClassName = b('close');

        if (className !== closeClassName) {
            const {itemIndex} = this.state;
            const direction = evt.pageX > this._itemsOffsets[itemIndex] ? 'next' : 'prev';
            this._carousel[direction]();
        }
    }

    /**
     * @private
     */
    _onClose() {
        if (this._isOpen) {
            this._changeHistory(false);
        }

        this.setState({
            itemIndex: null,
        });
    }

    /**
     * @private
     */
    _onHashChange() {
        if (this._isOpen) {
            this._isOpen = false;
            this._close();
        }
    }

}

ProgramGallery.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.object.isRequired
    ).isRequired,
    programId: PropTypes.number,
    eventId: PropTypes.number,
    isLayoutColumnsSmall: PropTypes.bool,
    isLayoutColumnsLarge: PropTypes.bool,
};

module.exports = withI18n(ProgramGallery);
